/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2026 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";
import {
  REGEX_PATH,
  TransformData,
  TransformFieldProps,
} from "@advapacs/common";
import Validator from "../validator";

const RegexPath: FunctionComponent<TransformFieldProps> = ({
  disabled,
  id,
  errors,
  transform,
  onValueChangeHandler,
}: TransformFieldProps) => {
  const { t } = useTranslation("form");

  const dispatchNewValue = (trans: TransformData) => {
    onValueChangeHandler({
      type: REGEX_PATH,
      id,
      transform: trans,
    });
  };

  const updateExpression = (event: React.FormEvent<HTMLInputElement>) => {
    dispatchNewValue({
      regex: event.currentTarget.value,
    });
  };

  const hasError = () => {
    return (
      errors.find((item) => item.id === id && item.type === REGEX_PATH) !==
      undefined
    );
  };

  return (
    <div className="row">
      <div className="col-md-8">
        <input
          disabled={disabled}
          id={`${id}_expression`}
          type="text"
          name="expression"
          className="form-control mb-1"
          placeholder={t("hl7.expression")}
          onChange={updateExpression}
          value={transform?.regex}
        />
        {hasError() && !transform?.regex && (
          <label
            className="validation-invalid-label"
            htmlFor={`${id}_expression`}
          >
            {t("hl7.field_required")}
          </label>
        )}
        {hasError() &&
          transform?.regex &&
          !Validator.validateExpressionRegex(transform?.regex) && (
            <label
              className="validation-invalid-label"
              htmlFor={`${id}_expression`}
            >
              {t("invalid_expression")}
            </label>
          )}
      </div>
    </div>
  );
};

export default RegexPath;
